module.exports = __webpack_public_path__ + "img/logo_feat_software_text.6d3f1a62.png";